module.exports = __webpack_public_path__ + "static/computer-vision-a3a9b22318b129a95f5869b146d4028e.jpg";